export default "__VITE_ASSET__9f04236d__"